// document.getElementById('popupLink').addEventListener('click', function() {
//   document.getElementById('popup').style.display = 'block';
// });

// function closePopup() {
//   document.getElementById('popup').style.display = 'none';
// }

let popupLink = document.getElementById('weightPopupLink');

if (popupLink) {  // Check if the element exists
  popupLink.addEventListener('click', function() {
    document.getElementById('popup').style.display = 'block';

    // Add an event listener to close the popup when clicking outside of it
    window.addEventListener('click', closePopupOutside);
  });
}
  
  function closePopup() {
    document.getElementById('popup').style.display = 'none';
    window.removeEventListener('click', closePopupOutside);  // Remove the event listener
  }
  
  function closePopupOutside(event) {
    const popup = document.getElementById('popup');
    if (event.target === popup) {
      closePopup();
    }
  }

//   document.addEventListener("DOMContentLoaded", function() {
//     let triggers = document.querySelectorAll('.search-trigger');

//     if (triggers.length > 0) { // Check if there are any elements with the class 'search-trigger'
//         triggers.forEach(function(trigger) {
//             trigger.addEventListener('click', function(event) {
//                 event.preventDefault();

//                 let toggleElems = document.querySelectorAll('.toggle-header-search-form');
//                 console.log(toggleElems);
//                 if (toggleElems.length > 0) { // Check if there are any elements with the class 'toggle-header-search-form'
//                     toggleElems.forEach(function(elem) {
//                         elem.classList.remove('toggle-header-search-form-hidden');
//                     });
//                 }
                
//                 this.classList.add('hidden');
//             });
//         });
//     }
// });

